import React from 'react'

const noop = () => Promise.reject(new Error('Not available'))

const initialState = {
  connecting: false,
  connected: false,
  closing: false,
  closingType: false,
  closed: false,
  clientConfiguration: undefined,
  hostContext: undefined,
  dataNotifier: undefined,
  actions: {
    launch: noop,
    close: noop,
    getWS: noop,
    closeWS: noop,
    messageWS: noop,
    setDimensions: noop,
    openLink: noop,
    getResource: noop,
    commandTo: noop
  },
  error: undefined,
}

const IframeClientContext = React.createContext(initialState)

export default IframeClientContext
